import { render, staticRenderFns } from "./IntegracaoList.vue?vue&type=template&id=b86b5458&scoped=true"
import script from "./IntegracaoList.vue?vue&type=script&lang=js"
export * from "./IntegracaoList.vue?vue&type=script&lang=js"
import style0 from "./IntegracaoList.vue?vue&type=style&index=0&id=b86b5458&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b86b5458",
  null
  
)

export default component.exports